import axios from 'axios';
import router from '@/router';
import { logoutUser } from '@/utils/auth';

const instance = axios.create({
baseURL: process.env.VUE_APP_API_BASE_URL,
 headers: {
  Accept: 'application/json',
  'Content-Type': 'application/json',
 },
});

// Add token to every request
instance.interceptors.request.use((config) => {
const token = localStorage.getItem('auth_token');
if (token && !config.url.includes('/login')) {
  config.headers.Authorization = `Bearer ${token}`;
}
return config;
});

// Global response error handler
instance.interceptors.response.use(
response => response,
error => {
  if (error.response) {
    const { status, data } = error.response;

    // Handle 401 Unauthorized (auto logout)
    if (status === 401) {
      logoutUser();
      router.push('/login');
      return Promise.reject({
        type: 'unauthenticated',
        message: data.message || 'Session expired. Please login again.',
      });
    }

    // Laravel-style validation errors
    if (data.status === 0 && data.errors) {
      return Promise.reject({
        type: 'validation',
        errors: data.errors,
        message: data.message || 'Validation failed.',
      });
    }

    // General error
    if (data.status === 0 && data.errors === null) {
      return Promise.reject({
        type: 'general',
        message: data.message || 'Something went wrong.',
      });
    }
  }

  // Network or unknown error
  return Promise.reject({
    type: 'network',
    message: 'Network error or server not reachable.',
  });
}
);

export default instance;
